// extracted by mini-css-extract-plugin
export var roundIcon = "Article-module--roundIcon--8dt3a";
export var sectionTop = "Article-module--sectionTop--+Exka";
export var sectionTopContent = "Article-module--sectionTopContent--2m6bT";
export var sectionTopLink = "Article-module--sectionTopLink--rY9hh";
export var sectionTopNoPadding = "Article-module--sectionTopNoPadding--iG9vv";